import type { Crumb } from './routeHandles.types'

// Standalone function so the path-to-crumb mapping is unit testable without mounting the router.
export function trackerBreadcrumbs(pathname: string): Crumb[] {
  const trail: Crumb[] = [{ label: 'AEO Optimization', path: '/tracker' }]

  if (pathname.startsWith('/tracker/performance')) {
    trail.push({ label: 'Performance' })
  } else if (pathname.startsWith('/tracker/site-health')) {
    trail.push({ label: 'Site Health' })
  } else if (pathname.startsWith('/tracker/history')) {
    trail.push({ label: 'History' })
  } else if (pathname.startsWith('/tracker/schedules')) {
    trail.push({ label: 'Schedules' })
  } else if (pathname.startsWith('/tracker/run/')) {
    trail.push({ label: 'Run' })
  }

  return trail
}
